<template>
  <div class="w-full">
    <div class="flex w-full items-start gap-[8px]">
      <DsInput
        :id="id"
        :name="name"
        :model-value="modelValue"
        type="text"
        :placeholder="placeholder"
        :disabled="disabled"
        :state="showError ? 'error' : undefined"
        :error="showError ? errorText : ''"
        :help-text="helpText"
        aria-label="Passcode"
        autocapitalize="off"
        autocorrect="off"
        autocomplete="off"
        spellcheck="false"
        class="min-w-0 flex-1"
        @update:model-value="$emit('update:modelValue', $event)"
        @keyup.enter="submit"
      />
      <DsButton
        variant="primary"
        theme="light"
        size="56"
        :disabled="isSubmitDisabled"
        :class="isSubmitDisabled ? '!border-light !bg-light !text-white !opacity-100' : ''"
        @click="submit"
      >
        {{ buttonLabel }}
      </DsButton>
    </div>
  </div>
</template>

<script>
import { Button as DsButton, Input as DsInput } from '@team-hogc/hogc-one-design-system';

export default {
  name: 'PasscodeVerificationField',
  components: {
    DsButton,
    DsInput,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Passcode',
    },
    buttonLabel: {
      type: String,
      default: 'Enter',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    helpText: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: undefined,
    },
    name: {
      type: String,
      default: undefined,
    },
  },
  emits: ['update:modelValue', 'submit'],
  computed: {
    hasValue() {
      return this.modelValue.trim().length > 0;
    },
    isSubmitDisabled() {
      return this.disabled || !this.hasValue;
    },
    showError() {
      return this.hasError || Boolean(this.error);
    },
    errorText() {
      return this.error || (this.hasError ? 'This field has an error' : '');
    },
  },
  methods: {
    submit() {
      if (this.isSubmitDisabled) return;
      this.$emit('submit');
    },
  },
};
</script>
